import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/services/auth.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    standalone: false
})
export class AdminComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.isOnAdminScreen = true;
  }
}
